import orderKegsSagas from './orderKegs'
import editOrCancelKegsSagas from './editOrCancelKegs'

// CODE_COMMENTS_11
export default [
  ...orderKegsSagas,
  ...editOrCancelKegsSagas,
]
